
import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { Conversation } from "@/types/conversation";
import { Message } from "@/types/message";
import { exportConversationToPdf } from "@/utils/pdf-export";

export const usePdfExport = (
  conversation: Conversation,
  messages: Message[],
  userFullName: string = "Customer"
) => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(0);
  const { toast } = useToast();

  const handleExportToPdf = async () => {
    if (!conversation) return;
    
    setIsExporting(true);
    setExportProgress(0);
    
    try {
      // Track progress with callback function
      const updateProgress = (progress: number) => {
        setExportProgress(progress);
      };
      
      // Export the conversation to PDF with progress tracking
      const filename = await exportConversationToPdf(
        conversation, 
        messages, 
        userFullName, 
        updateProgress
      );
      
      // Show success toast
      toast({
        title: "PDF Downloaded",
        description: `Saved as ${filename}`,
      });
    } catch (error) {
      console.error("Error exporting PDF:", error);
      toast({
        variant: "destructive",
        title: "Export Failed",
        description: "There was a problem generating the PDF. Please try again.",
      });
    } finally {
      setIsExporting(false);
      setExportProgress(0);
    }
  };

  return {
    isExporting,
    exportProgress,
    handleExportToPdf
  };
};
